// SmartPage — حاوية الصفحة الموحّدة (خلفية + لون نص + هوامش + عرض أقصى متمركز).
// جزء من مجموعة مكوّنات SmartPage الموحّدة على ثيم SMART_COLORS (3.4.0 / N13).
import React from 'react';
import { Box } from '@mui/material';
import { SMART_COLORS as C } from '../../theme/smartStableTheme';

export default function SmartPage({ children, maxWidth = 1280, sx }) {
  return (
    <Box sx={{ bgcolor: C.page, color: C.text, minHeight: '100%', p: { xs: 2, md: 3 }, ...sx }}>
      <Box sx={{ maxWidth, mx: 'auto' }}>{children}</Box>
    </Box>
  );
}
